import cn from 'classnames';
import React from 'react';
import { block } from './utils';

export interface ModalBodyProps {
  children?: React.ReactNode;
  className?: string;
}

const ModalBody: React.FC<ModalBodyProps> = ({ children, className }) => (
  <div className={cn(block('body'), className)}>{children}</div>
);

export default ModalBody;
